import * as ProgressPrimitive from "@radix-ui/react-progress"
import clsx from "clsx"

import styles from "./ProgressBar.module.scss"
import { ProgressBarProps } from "./ProgressBar.types"

export default function ProgressBar(props: ProgressBarProps) {
    const { value, className, indicatorClassName, ...rest } = props

    return (
        <ProgressPrimitive.Root data-slot="progress" className={clsx(styles.base, className)} {...rest}>
            <ProgressPrimitive.Indicator
                data-slot="progress-indicator"
                className={clsx(styles.indicator, indicatorClassName)}
                style={{ transform: `translateX(-${100 - (value || 0)}%)` }}
            />
        </ProgressPrimitive.Root>
    )
}
